import GrowthDiscoveryExperiments from 'bundles/epic/clients/GrowthDiscovery';

export const getShouldShowProductCardDensitySkills = () =>
  GrowthDiscoveryExperiments.preview('cSerpProductCardDensitySkills');
export const getShouldShowProductCardDensitySkillsWithImpression = () =>
  GrowthDiscoveryExperiments.get('cSerpProductCardDensitySkills');
export const getShouldShowProductCardDensityRating = () =>
  GrowthDiscoveryExperiments.preview('cSerpProductCardDensityRating');
export const getShouldShowProductCardDensityRatingWithImpression = () =>
  GrowthDiscoveryExperiments.get('cSerpProductCardDensityRating');

// new autocomplete
export const getShowNewAutocomplete = () =>
  GrowthDiscoveryExperiments.preview('showNewAutocomplete') ||
  GrowthDiscoveryExperiments.preview('showNewAutocompleteDogfooding');
export const impressIntoNewAutocompleteExperiment = () => GrowthDiscoveryExperiments.get('showNewAutocomplete');

// filter experiment utils
export const impressIntoFilterExperiment = () => GrowthDiscoveryExperiments.get('serpFilterVariant');
export const isInControlFilterVariant = () => GrowthDiscoveryExperiments.preview('serpFilterVariant') === 0;
export const isInFilterVariant1 = () => GrowthDiscoveryExperiments.preview('serpFilterVariant') === 1;
export const isInFilterVariant2 = () => GrowthDiscoveryExperiments.preview('serpFilterVariant') === 2;
export const isInFilterTestVariant = () => GrowthDiscoveryExperiments.preview('serpFilterVariant') >= 1;
// end filter variant utils

export const getShowNewSERPSuggestedSearch = () => GrowthDiscoveryExperiments.get('showNewSERPSuggestedSearch');

// Browse in SERP experiment utils
export const getShouldShowBrowseInSERP = () => GrowthDiscoveryExperiments.preview('showBrowseInSerp');
export const getShouldShowBrowseInSERPWithImpression = () => GrowthDiscoveryExperiments.get('showBrowseInSerp');

export const getShouldShowGoogleAISpotlightCollectionsInSearch = () =>
  GrowthDiscoveryExperiments.preview('showGoogleAISpotlightCollectionsInSearch');
export const getShouldShowGoogleAISpotlightCollectionsInSearchWithImpression = () =>
  GrowthDiscoveryExperiments.get('showGoogleAISpotlightCollectionsInSearch');

export const getShouldUseRemoveFilterHack = () => GrowthDiscoveryExperiments.get('opensearchFilteredFacets');
